module.exports = __webpack_public_path__ + "img/logo.da5b13b6.svg";